export enum UserType {
  Agent = 'agent',
  Automatic = 'automatic',
  BotAgent = 'bot_agent',
  Customer = 'customer',
  Supervisor = 'supervisor',
  Visitor = 'visitor',
}
